export default __webpack_public_path__ + "static/media/P200_Micropipette.93aa6785.svg";